import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { BottomNav, Sidebar } from './BottomNav';
import { Loader2 } from 'lucide-react';

export function MainLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#3B82F6]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user && !user.onboarding_completed) {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <div className="min-h-screen bg-[#0B0F1A]">
      <Sidebar />
      <main className="md:ml-64 pb-24 md:pb-8 min-h-screen">
        <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 py-6">
          <Outlet />
        </div>
      </main>
      <BottomNav />
    </div>
  );
}

export function AuthLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#3B82F6]" />
      </div>
    );
  }

  // If not logged in → allow login/register pages
  if (!user) {
    return <Outlet />;
  }

  // If logged in and finished onboarding → go dashboard
  if (user.onboarding_completed) {
    return <Navigate to="/dashboard" replace />;
  }

  // If logged in but not onboarded → go onboarding
  return <Navigate to="/onboarding" replace />;
}

export function OnboardingLayout() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0B0F1A] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#3B82F6]" />
      </div>
    );
  }

if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user && user.onboarding_completed) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
